import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../shared-services/snack.service';
import { SecurityService } from '../security/security.service';
import { BackendService } from '../core/backend.service';
import { Configuracion } from './configuracion.model';

@Injectable()
export class ConfiguracionResolver implements Resolve<Configuracion> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected securityService: SecurityService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {

        return await this.backendService.get(Configuracion, Configuracion.path).toPromise();
    } catch (error) {

        this.router.navigate(['/configuraciones']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuracion/configuracion.resolver.ts